import { render } from "./PastSessions.vue?vue&type=template&id=7065ea2c"
import script from "./PastSessions.vue?vue&type=script&lang=js"
export * from "./PastSessions.vue?vue&type=script&lang=js"

import "./PastSessions.vue?vue&type=style&index=0&id=7065ea2c&lang=css"
script.render = render

export default script